module.exports = __webpack_public_path__ + "img/undressed-woman-3.40e501bf.jpg";